import { Button, Grid, MenuItem, Popover } from '@mui/material';
import { useState } from 'react';
import { Form } from 'react-final-form';
import { useDispatch, useSelector } from 'react-redux';
import SelectField from 'common/forms/SelectField';
import TextField from 'common/forms/TextField';
import { filterManufacturers } from 'store/thunks/manufacturerManagementThunk';

const ALL_STATUSES = 'ALL';

const ManufacturerManagementFilterButton = () => {
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const filter = useSelector(({ inventory }) => inventory.manufacturerManagement.filter);

  const popoverId = anchorEl ? 'manufacturer-management-filter-popover' : undefined;

  const handleOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleApplyFilter = (formData) => {
    setAnchorEl(null);
    dispatch(
      filterManufacturers({
        filter: {
          manufacturer: formData.manufacturer?.trim() || undefined,
          status: formData.status === ALL_STATUSES ? undefined : formData.status,
        },
      })
    );
  };

  return (
    <>
      <Button
        sx={{ height: 33 }}
        variant='outlined'
        color='secondary'
        onClick={handleOpen}
        aria-describedby={popoverId}
      >
        Filters
      </Button>

      <Popover
        id={popoverId}
        open={!!anchorEl}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Grid container sx={{ p: 1.5, width: 280 }} spacing={2} direction='column'>
          <Grid item>
            <Form
              initialValues={{
                manufacturer: filter.manufacturer,
                status: filter.status ?? ALL_STATUSES,
              }}
              onSubmit={handleApplyFilter}
              render={({ handleSubmit }) => (
                <form onSubmit={handleSubmit} noValidate>
                  <Grid item sx={{ py: 0.5 }}>
                    <TextField
                      label='Manufacturer Name'
                      name='manufacturer'
                      id='manufacturer-filter-manufacturer'
                    />
                  </Grid>
                  <Grid item sx={{ py: 0.5 }}>
                    <SelectField label='Status' name='status' id='manufacturer-filter-status'>
                      <MenuItem value='ACTIVE'>Active</MenuItem>
                      <MenuItem value='INACTIVE'>Inactive</MenuItem>
                      <MenuItem value={ALL_STATUSES}>All</MenuItem>
                    </SelectField>
                  </Grid>
                  <Grid container justifyContent='flex-end' sx={{ mt: 1 }}>
                    <Button variant='contained' type='submit'>
                      Apply
                    </Button>
                  </Grid>
                </form>
              )}
            />
          </Grid>
        </Grid>
      </Popover>
    </>
  );
};

export default ManufacturerManagementFilterButton;
